
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Change Password'"></app-st-header-title>
      <br>
      <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
        <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
        <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
          <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
        </div>
        <br>
      </div>
      <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
        <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
          <b>{{successMsg.field}}:</b> {{successMsg.detail}}
        </div>
        <br>
      </div>
      <div class="container st-form">
        <div>
          <p class="webtext-black"><b>Password Policy:</b></p>
          <ul class="webtext-black">
            <li>Password must be at least 10 characters.</li>
            <li>Password must contain at least one lowercase letter.</li>
            <li>Password must contain at least one uppercase letter.</li>
            <li>Password must contain at least one number.</li>
          </ul>
        </div>
        <div>
          <app-st-input-sensitive-text [idVal]="'current-password-text-id'" [label]="'Current Password'"></app-st-input-sensitive-text>
          <app-st-input-sensitive-text [idVal]="'new-password-text-id'" [label]="'New Password'"></app-st-input-sensitive-text>
          <app-st-input-sensitive-text [idVal]="'repeat-password-text-id'" [label]="'Repeat New Password'"></app-st-input-sensitive-text>
        </div>
        <br>
        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <app-st-button [idVal]="'save-button-id'" [label]="'Save'" [primary]="true"
                         (click)="this.onSubmit()"></app-st-button>
          <app-st-button-cancel [idVal]="'cancel-button-id'" [label]="'Cancel'" [primary]="false"
                         (click)="this.onCancel()"></app-st-button-cancel>
        </div>
      </div>
    </div>
  </div>
</div>
